import type { PaginatedData, Project } from '../data/projectTypes'

// Seed a freshly-created project into an already-cached project-list page so subscribed lists (the
// AppShell sidebar among them) reflect it immediately, without invalidating the LIST tag and firing a
// GET /api/projects refetch behind the create — the round-trip that #3995 flagged on the onboarding
// waterfall. The server orders lists updated_at DESC, so a brand-new project belongs at the front; we
// cap the page back to its own pageSize (the trailing row spills to the next page, exactly as it would
// with the server's OFFSET pagination) and bump the totals. A project already present (a retried
// create, or a list that raced a refetch) is a no-op so nothing is duplicated or double-counted.
export function seedProjectIntoList(page: PaginatedData<Project>, created: Project): void {
  if (page.items.some((project) => project.id === created.id)) return
  page.items.unshift(created)
  if (page.items.length > page.pageSize) page.items.splice(page.pageSize)
  page.total += 1
  if (typeof page.totalAll === 'number') page.totalAll += 1
}
